import React, { useState } from "react";
import { Board, Chart, Item, Person, Settings } from "@vibe/icons";
import { Divider } from "@vibe/core";
import clsx from "clsx";
import AccountSettings from "../components/Navbar/Settings/SettingsContent/AccountSettings";
import BoardSettings from "../components/Navbar/Settings/SettingsContent/BoardSettings";
import ItemSettings from "../components/Navbar/Settings/SettingsContent/ItemSettings";
import UsageSettings from "../components/Navbar/Settings/SettingsContent/UsageSettings";

type SettingsTab = {
  id: string;
  label: string;
  icon: React.ReactNode;
  content: React.ReactNode;
};

const tabs: SettingsTab[] = [
  {
    id: "account",
    label: "Account",
    icon: <Person className="w-4 h-4" />,
    content: <AccountSettings />,
  },
  {
    id: "board",
    label: "Board Settings",
    icon: <Board className="w-4 h-4" />,
    content: <BoardSettings />,
  },
  {
    id: "item",
    label: "Item settings",
    icon: <Item className="w-4 h-4" />,
    content: <ItemSettings />,
  },
  {
    id: "usage",
    label: "Usage",
    icon: <Chart className="w-4 h-4" />,
    content: <UsageSettings />,
  },
];

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState("account");

  return (
    <div className="flex flex-row w-full h-screen text-[#323338] !font-figtree">
      {/* {SideBar} */}
      <div className="min-w-[16rem] bg-[#F5F6F8]">
        <div className="flex gap-2 items-center p-4 font-medium">
          <Settings size={16} />
          <span>Settings</span>
        </div>
        <Divider className="!m-0" />

        <nav className="p-2">
          {tabs.map((tab: any) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={clsx(
                "!font-figtree flex items-center gap-3 w-full px-3 py-2 text-sm rounded-md text-[#323338]",
                "transition-colors duration-200",
                "border-0",
                "hover:bg-primary-background-hover",
                "cursor-pointer",
                activeTab === tab.id ? "bg-primary-selected" : "bg-transparent"
              )}
            >
              {tab.icon}
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Content */}
      <div className="overflow-y-auto flex-1 px-5 py-5">{tabs.find((tab: any) => tab.id === activeTab)?.content}</div>
    </div>
  );
};

export default SettingsPage;
